/// <amd-module name="Search/Shared/Components/SearchInput/SearchInput.Props" />
import { ObservableValue, IObservableValue } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";
import { IInputLabel } from "Search/Shared/Base/Types";

export interface ISearchInputProps {
    pageContext: IVssPageContext;


    selectedTabId: IObservableValue<string>;

    /**
    * Label to notify whether it is account or project context.
    */
    contextLabel: string;

    /**
     * Observable which the component depends on, modifies whenever input query text changes.
     */
    defaultText: ObservableValue<string | undefined>;

    /**
     * Delegate invoked to fire search from input box.
     */
    onExecuteSearch(text: string, openInNewTab: boolean): void;

    /**
    * Watermark text in case there is not text to show.
    * aria-label property for the input mentioning the entity and context
    * at which search is being performed.
    */
    inputLabel: ObservableValue<IInputLabel>;

    /**
    * Delegate invoked when the help pop up needs to be dismissed.
    */
    onDismissHelp?: () => void;

    /**
    * Delegate invoked when the text in the search input box is cleared out.
    */
    onRemoveText?: () => void;

    /**
     * Delegate invoked whenever the input box recieves focus.
     */
    onFocus?: () => void;
}